import PubnubServiceImpl from "@/App/services/PubnubService";
import { useCasesStore } from "@/Pages/Cases/store";
import type { User } from "@/App/user/User";

enum LiveUpdateTypes {
  locationUpdate = "locationUpdate",
  updateList = "UPDATE_CASE_LIST",
  updateCase = "UPDATE_CASE",
  updateField = "UPDATE_FIELD",
  newMedia = "NEW_MEDIA",
  update = "update",
  create = "create",
}

export const LiveUpdateService = {
  startListeningForLiveUpdate(user: User): Promise<void> {
    return PubnubServiceImpl.getInstance().subscribe<Record<string, unknown>>({
      channels: user.channels.dashboard,
      types: Object.values(LiveUpdateTypes),
      callback: (type, message) => {
        const casesStore = useCasesStore();
        switch (type) {
          case LiveUpdateTypes.updateList:
            casesStore.getCases();
            break;
          case LiveUpdateTypes.locationUpdate:
          case LiveUpdateTypes.updateCase:
          case LiveUpdateTypes.update:
          case LiveUpdateTypes.updateField:
          case LiveUpdateTypes.newMedia:
          case LiveUpdateTypes.create:
            casesStore.getCase({ caseId: message.payload.case as string });
            break;
        }
      },
    });
  },
};
